<template>
    <span v-bind:class="{ 'center' : center }">
        <span
            v-if="!editingName"
            v-on:click.stop="edit()"
            >
            {{name}}&nbsp;&nbsp;
            <i
                v-if="!locked"
                v-bind:style="style"
                class="fa fa-pencil mdb-icon-btn edit">
            </i>
        </span>
        
        <span v-else>
            <input 
                v-if="!textArea"
                ref="input"
                v-bind:class="inputClasses"
                v-bind:maxlength="maxLength"
                type="text"
                v-model="newName"
                v-on:blur="rename()"
                v-on:keyup.enter="rename()"
            />
            <textarea 
                v-else
                ref="input" 
                wrap="off" 
                autofocus
                v-bind:class="inputClasses"
                v-bind:maxlength="maxLength"
                v-model="newName"
                v-on:blur="rename()"
                v-on:input="resize"
            />
        </span>
       
    </span>
</template>

<script>
    import $ from 'jquery'
    
    export default {
        name: "renamable-property",
        created (){
            this.newName = this.name;
        },
        methods: {
            edit() {
                if(!this.locked)
                    this.editingName = true
            },
            rename() {
                 if(this.name !== this.newName){
                    this.$emit('rename-property', this.newName);
                }
                this.editingName = false;
            },
            resize() {
                let textarea = this.$refs.input;

                $(textarea)
                    .width (200)
                    .height(50)
                    .width (textarea.scrollWidth)
                    .height(textarea.scrollHeight);
            }
        },
        computed: {
            style() {
                return this.locked ? 'cursor: default;' : 'cursor: pointer;';
            }
        },
        watch: {
            editingName(value) {
                if(value)
                    this.$nextTick(() => {
                        this.$refs.input.focus();

                        if(this.textArea)
                            this.resize();
                    });
                else {
                    this.newName != '' ? this.newName : '<empty>';
                }
            },
            name(value){
                //Our actual editor should change along with external changes
                if(!this.editingName){
                    this.newName = value;
                }
            }
        },
        data() {
            return {
                newName: '',
                editingName: false
            }
        },
        props: {
            name: {
                type: String,
                required: true
            },
            center: {
                type: Boolean,
                required: false
            },
            inputClasses: {
                type: String,
                required: false
            },
            textArea: {
                type: Boolean,
                default: false
            },
            locked: {
                type: Boolean,
                default: false
            },
            maxLength: {
                type: Number,
                required: false
            }
        }
    }
</script>

<style scoped>

.center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

textarea .fullscreen {
    overflow: hidden;
    width: 200px;
    height: 50px;
    padding: 0;
}

</style>